import React from 'react';
import '../styles/theme.css';
import '../styles/Login.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LoginInstrumentReference from '../components/LoginInstrumentReference';
import LoginIdentityConsole from '../components/LoginIdentityConsole';
/* IMPORTS */

function LoginPage() {
  return (
    <div className="lo-root">
      <div id="loginnavbarslot" className="lo-slot-loginnavbarslot">
        <Navbar activePage={"Login"} />
      </div>
      <div id="loginidentityconsole" className="lo-slot-loginidentityconsole">
        <LoginIdentityConsole />
      </div>
      <div id="logininstrumentreference" className="lo-slot-logininstrumentreference">
        <LoginInstrumentReference />
      </div>
      <div id="loginfooterslot" className="lo-slot-loginfooterslot">
        <Footer />
      </div>
    </div>
  );
}

export default LoginPage;